import requests from "./axios";

/**
 * 查询平台列表
 */
export const getPlatInfoList = ()=>{
    return requests({
        url: '/plat/list',
        method: 'get'
    });
};

/**
 * 注意，封装的axios中设置了baseUrl为/api，所以这里不需要写/api了
 */
/**
 * 查询音乐
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const searchMusic = (params)=>{
    return requests({
        url: '/search',
        method: 'get',
        params: params
    });
};

/**
 * 转换音乐
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const convertMusic = (params)=>{
    return requests({
        url: '/convert',
        method: 'get',
        params: params
    });
};


/**
 * 验证token
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const verifyLogin = (params)=>{
    return requests({
        url: '/login/verify',
        method: 'post',
        data: params
    });
};


/*
 * 获取用户歌单
 */
export const getCollection = ()=>{
    return requests({
        url: '/collect',
        method: 'get'
    });
};

/*
 * 添加（创建）歌单
 * @param data 歌单对象
 */
export const addCollection = (data)=>{
    return requests({
        url: '/collect/add',
        method: 'post',
        data: data
    });
};

/*
 * 修改歌单
 * @param data 歌单对象
 */
export const updateCollection = (data)=>{
    return requests({
        url: '/collect/update',
        method: 'post',
        data: data
    });
};

/*
 * 删除歌单
 * @param id 歌单id
 */
export const deleteCollection = (id)=>{
    return requests({
        url: '/collect/delete/' + id,
        method: 'post'
    });
};

/*
 * 查询歌曲列表
 * @param params 歌曲信息查询对象：
 * {
 *      collectionId:1,
 *      pageNum: 1,
 *      pageSize: 10
 * }
 */
export const getSongInfoList = (params)=>{
    return requests({
        url: '/play/list',
        method: 'get',
        params: params
    });
};

/**
 * 添加歌曲
 * @param data 歌曲对象list
 */
export const addSongInfo = (data)=>{
    return requests({
        url: '/play/add',
        method: 'post',
        data: data
    });
};

/**
 * 从歌单删除歌曲
 * @param id 歌单id
 */
export const deleteSongInfo = (id)=>{
    return requests({
        url: '/play/delete/' + id,
        method: 'post',
    })
};


